import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example " defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>
                    <ListGroup className='c-lineheight3'>
                        <b className='text-danger fs-5'>Undergraduate</b>
                        <ListGroup.Item as={Link} action to="/b-tech-curriculum" className={`px-3 ${activeIndex === 0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                             B.Tech
                        </ListGroup.Item>
                        <b className='text-danger fs-5'>Postgraduate</b>

                        <ListGroup.Item as={Link} action to="/m-tech-curriculum" className={`px-3 ${activeIndex === 1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Tech
                        </ListGroup.Item>
                       
                        <ListGroup.Item as={Link} action to="/dual-degree-curriculum" className={`px-3 ${activeIndex === 2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Dual Degree (B.Tech + M.Tech)
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/btech-ms-dual-degree-curriculum" className={`px-3 ${activeIndex === 5 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Dual Degree (B.Tech + M.S.(R))
                        </ListGroup.Item>
                       
                        <ListGroup.Item as={Link} action to="/m-sc-curriculum" className={`px-3 ${activeIndex === 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Sc
                        </ListGroup.Item>
                        
                        <ListGroup.Item as={Link} action to="/master-of-public-policy-mpp-curriculum" className={`px-3 ${activeIndex === 4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Master of Public Policy (MPP)
                        </ListGroup.Item>

                    </ListGroup>
                </Col>   
            </Row>
        </Tab.Container>
    );
}

export default Main;